<template>
  <NuxtLink :to="startUrl">
    <div class="text-coral flex items-end gap-2">
      <AtomIcon name="bb-logo-name" />
      <div class="text-[0.625rem] leading-none py-1 font-bold bg-sky text-ocean rounded-sm px-[0.375rem] -mb-px">BETA</div>
    </div>
  </NuxtLink>
</template>

<script setup>
// const route = useRoute()
const fat = useFatStore()

// Set start URL
const startUrl = computed(() => fat.city?.slug ? `/${fat.city?.slug}` : '/')

// // Base slug
// const baseSlug = computed(() => route.params?.all ? route.params?.all[0] : '')

// // const startUrl = computed(() => (fat.cityId && fat.city?.slug !== baseSlug.value) 
// //   ? `/${fat.city?.slug}` 
//   : '/' )
</script>

<style lang="scss" scoped>
.app-nav {
  @apply grid gap-12;
}
</style>